import PropTypes from 'prop-types';
import React from 'react';

import { Label, Space, Text } from 'rebass';
import { Flex, Box } from 'reflexbox';

import config from 'frontend/config';

import Icon from './Icon';

class ToggleView extends React.Component {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    //eventLabel: PropTypes.string,
    children: PropTypes.node.isRequired,
    defaultOpen: PropTypes.bool,
    hideArrow: PropTypes.bool,
    hideClickToOpenText: PropTypes.bool,
    // escape hatch to control state
    open: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    defaultOpen: true,
    hideArrow: false,
    hideClickToOpenText: true,
    //eventLabel: null,
    open: undefined,
    onClick: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: props.open !== undefined ? props.open : props.defaultOpen,
    };

    this.toggleOpen = this.toggleOpen.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open !== undefined && this.props.open !== prevProps.open) {
      this.setState({ open: this.props.open });
    }
  }

  toggleOpen() {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  }

  render() {
    const { label, children, hideArrow, hideClickToOpenText, onClick } = this.props;
    const { open } = this.state;

    return (
      <Box>
        <Label
          onClick={onClick || this.toggleOpen}
          style={{
            fontSize: '18px',
            color: config.colors.white,
            opacity: 0.9,
          }}
        >
          <Flex align="center">
            <Box>
              {label}
            </Box>
            <Space auto />
            {
              !hideArrow &&
              (
                <Box style={{ marginTop: 3 }} mr={1}>
                  {open
                    ? <Icon name="toggleClose" size="1.2em" />
                    : <Icon name="toggleOpen" size="1.2em" />}
                </Box>
              )
            }
          </Flex>
          {!open && !hideClickToOpenText && <Text small>Click to open</Text>}
        </Label>
        {open
          ? (
            <Box mt={1}>
              {children}
            </Box>
          ) :
          null}
      </Box>
    );
  }
}

export default ToggleView;
